import { Label } from "@packages/ds";
import styled from "styled-components";

export const MaxManualBackupLabelWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
`;

export const LabelInput = styled(Label)`
  margin-bottom: 0;
`;
